export * from "./constants/index";

export enum UserRole {
  SHIP = 1001,
  DOM = 1002,
  WHOUSE = 1003,
  FINANCE = 1004,
  ADMIN = 1005,
  CUST = 1006,
  STOR = 1007,
  CLERK = 1008,
  CLAIM = 1009,
  CNT = 1010,
  BUISN = 1011,
  USERMANAGER = 1012,
  TEST = 1013,
  PILOT = 1014,
  REQUESTS = 1015,
  AIR = 1016,
  NEWS = 1017,
  SYSADMIN = 1018,
  DOCUPLOAD = 1019,
}

export enum UserType {
  Agent = "A",
  Customer = "C",
  Employee = "E",
}

export enum ShipmentType {
  LCL = "LCL",
  FCL = "FCL",
  CAR = "CAR",
}

export enum TransferPlace {
  ADDRESS = "ADDRESS", // Picked up or delivered by samskip to address
  PORT = "PORT", // Picked up or delivered by samskip from port
}

export enum RefrigeratedType {
  N = "N",
  Y = "Y",
}

export enum AddressType {
  CEE = "CEE",
  SHP = "SHP",
}

export const PROCESSING = "processing";

export enum QuoteStatus {
  All = "All",
  Pending = "Pending",
  ReadyForApproval = "ReadyForApproval",
  Valid = "Valid",
  Expired = "Expired",
}

export enum QuoteStatusActions {
  Approve = "Approve",
  Decline = "Decline",
}

export enum QuoteStatusesLabel {
  All = "LABEL_ALL",
  Pending = "LABEL_PENDING",
  ReadyForApproval = "LABEL_READY_FOR_APPROVAL",
  Valid = "LABEL_VALID",
  Expired = "LABEL_EXPIRED",
}

export const enum QuoteDeclineIds {
  DECLINE_ANOTHER_COMPANY = 14,
  DECLINE_NO_TRANSPORT = 15,
  DECLINE_OTHER = 16,
}

/** Max sizes for a package. */
export const MAX_HEIGHT = 999.99;
export const MAX_WIDTH = 999.99;
export const MAX_LENGTH = 9999.99;
export const MAX_WEIGHT = 30000;

export const pageTitle = {
  is: "Þjónustuvefur",
  en: "Service Web",
};

export enum LinkOpenTypes {
  mainServiceWeb = 0,
  openPopupWindow = 1,
  openIframe = 2,
  openTabOrWindow = 3,
}

export enum NavigationLinks {
  quotes = "/shipments/quotes",
  domestic = "/domestic",
  bookingTemplates = "/shipments/templates",
}
export const SAMSKIP_SUBSYS = 1000;
export const AUTH_TOKEN_HEADER = "SamskipAuthToken";

export enum ShippingTypeBookingTemplates {
  LL = "L L",
  FF = "F F",
  LF = "L F",
  FL = "F L",
}

export enum BookingFilterByCustomers {
  CHOSEN_CUSTOMER = "CHOSEN",
  ALL_CUSTOMERS = "ALL",
}
